module.exports = __webpack_public_path__ + "static/media/cathay22_logo.774f109d.png";